import React from 'react'
import { ColdList } from "../helper/MenuList";
import MenuItem from '../components/MenuItem';
import '../styles/Cold.css'

function Cold() {
  return (
    <div className='cold'>
      <h1 className='coldTitle'>Extreme Cold</h1>
      <div className='coldList'>
        {ColdList.map((cardItem, key) => {
            return (
            <MenuItem 
                key={key}
                image={cardItem.image} 
                name={cardItem.name} 
                desc={cardItem.desc} />
            )
        })}
      </div>
    </div>
  )
}

export default Cold
